import React, { useRef, useCallback, useEffect, useState } from "react";
import classnames from "classnames";
import styles from "./index.module.scss";
import { useStore, StoreTypes } from "context";
import { ReaderZoomType } from "constants/ReaderTools";
import { ReaderToolsEvent } from "events/EventTypes";
import { EventBus } from "events/EventBus";
import * as types from "constants/actionTypes";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
//import { useCourse } from "customHooks/course";
import { debounce } from "util/debounce";
import { Roles } from "constants/role";
import {ReaderToolType} from 'constants/ReaderTools'

let scaleTemp = 1;

export const ExtendedPinchPanContainer = ({ 
	index, 
	children, 
	containerWidth, 
	containerHeight, 
	extendedCanvas
}) => {
	const [
		{
			style: { width, height },
		},
	] = useStore(StoreTypes.books);
	const [{ role }] = useStore(StoreTypes.user);
	const [{ extendedZoomState }, extendedContentDispatch] = useStore(StoreTypes.extendedContent);
	const { offsetX = 0, offsetY = 0, scale = 1, zoomType = ReaderZoomType.OriginZoom } = extendedZoomState;
	
	const [{ firestore, remoteZoomInfo }] = useStore(StoreTypes.course);
	const [{ canvas, isActive }] = useStore(StoreTypes.canvas);
	const [{ wheelScale, wheelX, wheelY }, setWheelInfo] = useState({
		wheelScale: 1,
		wheelX: 0,
		wheelY: 0,
	});
	const [transformWrapperParams, setTransformWrapperParams] = useState({});
	const ref = useRef(null);
	const updateScaleTimeout = useRef(null);
	const [{ toolType }] = useStore(StoreTypes.extendedContent);
	//const [, { setEventStatusToFirebase }] = useCourse();

	// 使用傳入的容器尺寸，如果沒有則使用 book 尺寸
	const effectiveWidth = containerWidth || width;
	const effectiveHeight = containerHeight || height;

	// 使用正確的 canvas 實例
	const targetCanvas = extendedCanvas || null;

	const panningHandler = useCallback(
		(e) => {
			const scaleX = e.positionX / (effectiveWidth * e.scale - effectiveWidth);
			const scaleY = e.positionY / (effectiveHeight * e.scale - effectiveHeight);
			const zoomInfo = {
				scaleX,
				scaleY,
				scale: e.scale,
				windowWidth: effectiveWidth,
				del: "=",
			};

			EventBus.emit({
				event: ReaderToolsEvent.ZoomToolEvent,
				payload: { type: ReaderZoomType.PanZoom },
			});

			// firestore &&
			// 	setEventStatusToFirebase({
			// 		areaInfo: {
			// 			type: ReaderZoomType.PanZoom,
			// 			zoomInfo,
			// 			timestamp: new Date().getTime(),
			// 		},
			// 	});

			const { positionX, positionY, scale } = e;
			const params = {
				positionX,
				positionY,
				scale,
			};

			// 簡化計算，移除 fullWidthInfo
			targetCanvas && targetCanvas.setViewportTransform([params.scale, 0, 0, params.scale, positionX, positionY]);

			extendedContentDispatch({
				type: types.SET_EXTENDED_CONTENT_SCALE_INFO,
				payload: {
					offsetX: positionX,
					offsetY: positionY,
					scale,
				},
			});

			setTransformWrapperParams(params);

			extendedContentDispatch({
				type: types.SET_EXTENDED_CONTENT_AREA_ZOOM_INTERACTIVE_OBJECTS,
				payload: {
					areaZoomInteractiveObjects: null,
				},
			});
		},
		[effectiveWidth, effectiveHeight, firestore, targetCanvas, extendedContentDispatch]
	);

	// useEffect(() => {
	// 	if (remoteZoomInfo) {
	// 		let { del, scaleX, scaleY } = remoteZoomInfo;
	// 		if (del === "+") {
	// 			scaleTemp = wheelScale + 0.04;
	// 		} else if (del === "-") {
	// 			scaleTemp = wheelScale - 0.04;
	// 		}
	// 		if (scaleTemp <= 1) {
	// 			scaleTemp = 1;
	// 		}
	// 		if (!scaleX) {
	// 			scaleX = 0;
	// 		}
	// 		if (!scaleY) {
	// 			scaleY = 0;
	// 		}

	// 		let params = {
	// 			positionX: (effectiveWidth * scaleTemp - effectiveWidth) * scaleX,
	// 			positionY: (effectiveHeight * scaleTemp - effectiveHeight) * scaleY,
	// 			scale: scaleTemp,
	// 		};
	// 		setTransformWrapperParams(params);
	// 		setWheelInfo({
	// 			wheelX: (effectiveWidth * scaleTemp - effectiveWidth) * scaleX,
	// 			wheelY: (effectiveHeight * scaleTemp - effectiveHeight) * scaleY,
	// 			wheelScale: scaleTemp,
	// 		});

	// 	}
	// }, [remoteZoomInfo, effectiveWidth, effectiveHeight, wheelScale]);

	const handler = useCallback((event) => {
		event.stopImmediatePropagation();
		return true;
	}, []);

	useEffect(() => {
		if (ref.current) {
			// ExtendedContent 不處理 mark mode
			ref.current.onmousemove = null;
			ref.current.onwheel = null;
		}
	}, []);

	useEffect(() => {
		if (ref.current) {
			ref.current.style.cursor = `inherit`;
			//ref.current.style.transform = `translate3d(${offsetX}px, ${offsetY}px, 0px) scale(${scale})`;
		}

		if (offsetX !== undefined) {
			scaleTemp = scale;
			setWheelInfo({
				wheelScale: scale,
				wheelX: offsetX,
				wheelY: offsetY,
			});
		}
	}, [scale, offsetX, offsetY]);

	const wheelHandler = useCallback(
		(e) => {
			var windowEvent = window.event;
			if (!windowEvent) return;
			var posX = windowEvent.clientX;
			var posY = windowEvent.clientY;

			const scaleX = e.positionX / (effectiveWidth * e.scale - effectiveWidth);
			const scaleY = e.positionY / (effectiveHeight * e.scale - effectiveHeight);
			EventBus.emit({
				event: ReaderToolsEvent.ZoomToolEvent,
				payload: { type: ReaderZoomType.WheelZoom },
			});
			const zoomInfo = {
				scaleX: scaleX ? scaleX : 1,
				scaleY: scaleY ? scaleY : 1,
				scale: e.scale,
				windowWidth: effectiveWidth,
				del: "=",
			};
			// firestore &&
			// 	setEventStatusToFirebase({
			// 		areaInfo: {
			// 			type: ReaderZoomType.RangeZoom,
			// 			zoomInfo,
			// 			timestamp: new Date().getTime(),
			// 		},
			// 	});

			const { positionX, positionY, scale } = e;
			const params = {
				positionX,
				positionY,
				scale,
			};

			// 簡化計算，移除 fullWidthInfo
			targetCanvas && targetCanvas.setViewportTransform([params.scale, 0, 0, params.scale, positionX, positionY]);

			extendedContentDispatch({
				type: types.SET_EXTENDED_CONTENT_SCALE_INFO,
				payload: {
					offsetX: positionX,
					offsetY: positionY,
					scale,
				},
			});
			setTransformWrapperParams(params);

			extendedContentDispatch({
				type: types.SET_EXTENDED_CONTENT_AREA_ZOOM_INTERACTIVE_OBJECTS,
				payload: {
					areaZoomInteractiveObjects: null,
				},
			});
		},
		[effectiveWidth, effectiveHeight, firestore, targetCanvas, extendedContentDispatch]
	);

	const zoomEnable =
		role === Roles.TUTOR_USER || role === Roles.ONECLASS_STUDENT
			? false
			: true;

	useEffect(() => {
		if (!targetCanvas) return;
		let params = null;
		switch (zoomType) {
			case ReaderZoomType.RangeZoom:
			case ReaderZoomType.LeftTop:
			case ReaderZoomType.RightTop:
			case ReaderZoomType.LeftBottom:
			case ReaderZoomType.RightBottom:
			case ReaderZoomType.AreaZoom:
				params = {
					positionX: Math.max(Math.min(offsetX, 0), effectiveWidth - targetCanvas.width * scale),
					positionY: Math.max(Math.min(offsetY, 0), effectiveHeight - targetCanvas.height * scale),
					scale: scale,
				};
				break;
			case ReaderZoomType.OriginZoom:
				params = {
					positionX: 0,
					positionY: 0,
					scale: 1,
				};
				// extendedContentDispatch({
				// 	type: types.SET_EXTENDED_CONTENT_SCALE_INFO,
				// 	payload: {
				// 		offsetX: 0,
				// 		offsetY: 0,
				// 		scale: 1,
				// 	},
				// });
				break;
			default:
				params = {
					positionX: offsetX,
					positionY: offsetY,
					scale: scale,
				};
				break;
		}
		if (!params) return;

		// 簡化計算，移除 fullWidthInfo
		targetCanvas && targetCanvas.setViewportTransform([params.scale, 0, 0, params.scale, params.positionX, params.positionY]);

		extendedContentDispatch({
			type: types.SET_EXTENDED_CONTENT_SCALE_INFO,
			payload: {
				offsetX: params.positionX,
				offsetY: params.positionY,
				scale: params.scale,
			},
		});

		setTransformWrapperParams({ ...params });
	}, [extendedContentDispatch, zoomType, scale, offsetX, offsetY, targetCanvas,effectiveWidth, effectiveHeight]); 
	
	const pinchHandler = useCallback(
		(e) => {
			const scaleX = e.positionX / (effectiveWidth * e.scale - effectiveWidth);
			const scaleY = e.positionY / (effectiveHeight * e.scale - effectiveHeight);
			EventBus.emit({
				event: ReaderToolsEvent.ZoomToolEvent,
				payload: { type: ReaderZoomType.WheelZoom },
			});
			const zoomInfo = {
				scaleX: scaleX ? scaleX : 1,
				scaleY: scaleY ? scaleY : 1,
				scale: e.scale,
				windowWidth: effectiveWidth,
				del: "=",
			};
			// firestore &&
			// 	setEventStatusToFirebase({
			// 		areaInfo: {
			// 			type: ReaderZoomType.RangeZoom,
			// 			zoomInfo,
			// 			timestamp: new Date().getTime(),
			// 		},
			// 	});

			const { positionX, positionY, scale } = e;
			const params = {
				positionX,
				positionY,
				scale,
			};

			// 簡化計算，移除 fullWidthInfo
			targetCanvas && targetCanvas.setViewportTransform([params.scale, 0, 0, params.scale, positionX, positionY]);

			extendedContentDispatch({
				type: types.SET_EXTENDED_CONTENT_SCALE_INFO,
				payload: {
					offsetX: positionX,
					offsetY: positionY,
					scale,
				},
			});
			setTransformWrapperParams(params);

			extendedContentDispatch({
				type: types.SET_EXTENDED_CONTENT_AREA_ZOOM_INTERACTIVE_OBJECTS,
				payload: {
					areaZoomInteractiveObjects: null,
				},
			});
		},
		[effectiveWidth, effectiveHeight, firestore, targetCanvas, extendedContentDispatch]
	);

	return (
		<div className={styles.extendedPinchPanContainer} id="ExtendedPinchPanContainer">
			<TransformWrapper
				doubleClick={{ disabled: true }}
				options={{
					minScale: 1,
					//maxScale: 2.7,
				}}
				scalePadding={{
					disabled: true,
				}}
				pan={{
					disabled: toolType !== ReaderToolType.Drag,
					paddingSize: 0,
				}}
				wheel={{
					step: 75,
				}}
				onPanning={panningHandler}
				onWheel={wheelHandler}
				onPinching={pinchHandler}
				zoomIn={{ disabled: !zoomEnable }}
				zoomOut={{ disabled: !zoomEnable }}
				{...transformWrapperParams}
			>
				{() => {
					return (
						<TransformComponent>
							<div
								ref={(v) => (ref.current = v)}
								className={classnames(styles.swipeContainer)}
							>
								{children}
							</div>
						</TransformComponent>
					);
				}}
			</TransformWrapper>
		</div>
	);
};
